
// import { create } from "zustand";
// import { persist } from "zustand/middleware";

// const COOKIE_TIMESTAMP_KEY = "user_cookie_set_time";

// const isCookieExpired = () => {
//     const timestamp = localStorage.getItem(COOKIE_TIMESTAMP_KEY);
//     if (!timestamp) return false;
//     const now = Date.now();
//     return now - parseInt(timestamp, 10) > 24 * 60 * 60 * 1000;
// };


// const getCookie = (name) => {
//     const cookies = document.cookie.split("; ");
//     for (let cookie of cookies) {
//         let [key, value] = cookie.split("=");
//         if (key === name) {
//             return JSON.parse(decodeURIComponent(value));
//         }
//     }
//     return null;
// };

// export const removeCookie = (name) => {
//     const domains = [
//         'myskill.club',
//         '.myskill.club',
//         'test.myskill.club',
//         '.test.myskill.club',
//         'dashboard.myskill.club',
//         '.dashboard.myskill.club',
//         'localhost',
//         'dev.myskill.club',
//         'devdashboard.myskill.club'
//     ];

//     const paths = ['/', '/web', '/web/studentdashboard'];

//     domains.forEach(domain => {
//         paths.forEach(path => {
//             document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}; Secure; SameSite=Lax`;
//         });
//     });

//     paths.forEach(path => {
//         document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; Secure; SameSite=Lax`;
//     });

//     document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Lax`;
// };




// const useAuthStore = create(
//     persist(
//         (set) => ({
//             user: null,
//             token: null,

//             login: ({ data, token }) => set({ user: data, token }),
//             setUser: (userData) => {
//                 set((state) => ({ ...state, user: userData })); 
//                 document.cookie = `user=${encodeURIComponent(JSON.stringify({ data: userData, token: useAuthStore.getState().token }))}; path=/; Secure; SameSite=Lax`;
//             },


//             logout: () => {
//                 set({ user: null, token: null });
//                 removeCookie("user");
//                 localStorage.removeItem(COOKIE_TIMESTAMP_KEY);

//             },
//         }),
//         {
//             name: "auth-storage",
//             getStorage: () => localStorage,
//         }
//     )
// );

// const user = getCookie("user");

// if (user && !isCookieExpired()) {
//     useAuthStore.getState().login({
//         data: user.data,
//         token: user.token
//     });
// } else {
//     removeCookie("user");
//     localStorage.removeItem(COOKIE_TIMESTAMP_KEY);
//     useAuthStore.getState().logout();
// }

// export default useAuthStore;



import { create } from "zustand";
import { persist } from "zustand/middleware";
import { removeCookie } from "../shared/utils/CookieUtils";
import axios from "axios";

const useAuthStore = create()(
    persist(
        (set) => ({
            user: null,
            token: null,
            refreshToken: null,
            login: (user, token, refreshToken) =>
                set({
                    user,
                    token,
                    refreshToken: refreshToken ?? null,
                }),

            setUser: (user) =>
                set((state) => ({
                    ...state,
                    user,
                })),

            logout: async () => {
                const env = window._env_ || {};
                const isProd = env.ENV === "production";
                const websiteUrl = isProd 
                    ? "https://dev.pedaskills.com/" 
                    : "http://localhost:3000/";
                
                const nodeLogoutUrl = `${env.API_PATH_NODE || "http://localhost:5000/api/"}logout`;
                const ssoLogoutUrl = "https://authlyapi.coretechvoyage.com/api/auth/logout";

                // Execute logout calls in parallel
                try {
                    await Promise.allSettled([
                        axios.post(nodeLogoutUrl, {}, { withCredentials: true }),
                        axios.post(ssoLogoutUrl, {}, { withCredentials: true })
                    ]);
                } catch (error) {
                    console.error("Logout API calls failed:", error);
                }

                // Clear client-side state
                set({ user: null, token: null, refreshToken: null });
                
                // Clear cookies and local storage
                removeCookie("user");
                removeCookie("accessToken");
                removeCookie("refreshToken");
                localStorage.removeItem("auth-storage");

                // Redirect to the landing page with logout parameter
                window.location.href = `${websiteUrl}`;
            },
        }),
        {
            name: "auth-storage",
        }
    )
);

export default useAuthStore;
